/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EverywareActivityItemViewModel {
  id?: string;
  clientIdentifier?: string | null;
  statementID?: string | null;
  everywarePatientID?: string | null;
  patientID?: string | null;
  channel?: string | null;
  eventType?: string | null;
  address?: string | null;
  dateAndTime?: string | null;
  accountNumber?: number;
  patientLastName?: string | null;
  patientFirstName?: string | null;
}
